import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
  public isAuthenticated$ = this.isAuthenticatedSubject.asObservable();

  constructor(
    private msalAuthService: MsalService,
    private router: Router
  ) {
    this.initializeMsal();
  }

  private async initializeMsal() {
    try {
      await this.msalAuthService.instance.initialize();
      await this.handleRedirectPromise();
    } catch (error) {
      console.error('MSAL initialization error:', error);
    }
  }

  private async handleRedirectPromise() {
    try {
      const result: AuthenticationResult | null = await this.msalAuthService.instance.handleRedirectPromise();
      console.log('Redirect promise result:', result);
      if (result?.account) {
        this.msalAuthService.instance.setActiveAccount(result.account);
        this.isAuthenticatedSubject.next(true);
        this.router.navigate(['/home']);
        return;
      }

      // Check auth status after handling redirect
      this.checkAuthStatus();
    } catch (error) {
      console.error('Error handling redirect promise:', error);
    }
  }

  private checkAuthStatus() {
    try {
      const accounts = this.msalAuthService.instance.getAllAccounts();
      console.log('MSAL accounts:', accounts);
      
      if (accounts.length > 0) {
        this.msalAuthService.instance.setActiveAccount(accounts[0]);
        this.isAuthenticatedSubject.next(true);
      } else {
        this.isAuthenticatedSubject.next(false);
      }
    } catch (error) {
      console.error('Error checking auth status:', error);
      this.isAuthenticatedSubject.next(false);
    }
  }

  login(): void {
    this.msalAuthService.loginRedirect({
      scopes: ['user.read', 'api://c44bf44b-17ab-436b-ab84-82b4425c90b3/api.read']
    });
  }

  logout(): void {
    this.msalAuthService.logoutRedirect();
    this.isAuthenticatedSubject.next(false);
  }

  getUser() {
    return this.msalAuthService.instance.getActiveAccount();
  }
}